import { useState } from 'react';
import { Form } from 'react-bootstrap';
import {
  isDevelopmentMode,
  setUseLocalAPI,
  getUseLocalAPI,
  getApiMode,
  getApiBaseUrl,
} from '../../services/api/config';

/**
 * Dev-only toggle to switch between local and production API.
 * Only visible when running on localhost.
 */
function ApiModeToggle() {
  const [useLocal, setUseLocal] = useState(getUseLocalAPI());

  if (!isDevelopmentMode()) {
    return null;
  }

  const handleChange = (e) => {
    const checked = e.target.checked;
    setUseLocalAPI(checked);
    setUseLocal(checked);
    window.location.reload();
  };

  return (
    <div className="d-flex align-items-center gap-2 ms-3">
      <Form.Check
        type="switch"
        id="api-mode-toggle"
        label={
          <small className="text-white-50">
            <strong>{getApiMode()}</strong>
            {!useLocal && getApiBaseUrl().startsWith('https') && (
              <> ({getApiBaseUrl().replace(/^https?:\/\//, '').split('/')[0]})</>
            )}
          </small>
        }
        checked={useLocal}
        onChange={handleChange}
        className="text-white"
      />
    </div>
  );
}

export default ApiModeToggle;
